module.exports = __webpack_public_path__ + "img/binamo-addition.ru.cb4745dd.jpg";